/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { queryInspections } from "src/services/AmplifyQuery";

import Layout from "src/components/layouts/Layout.react";
import Card from "src/components/cards/Card.react";
import LoadingCard from "src/components/loading/LoadingCard.react";
import InspectionTypeBadge from "src/components/badges/InspectionTypeBadge.react";
import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/InspectionTable.react";

/**
 * The Home Page component
 *
 * @author Thais Watanabe
 */
const Home = () => {
  const [inspections, setInspections] = useState([]);
  const [nextToken, setNextToken] = useState("");

  /**
   * useEffect
   */
  useEffect(() => {
    fetchInspections(null, []);
  }, []);

  /**
   * fetchInspections
   */
  async function fetchInspections(token, list) {
    queryInspections(setNextToken, setInspections, token, list);
  }

  return (
    <Layout title="登録済点検一覧">
      {!inspections.length > 0 && <LoadingCard />}
      {inspections.length > 0 && (
        <Card>
          <Table>
            <thead>
              <tr>
                <ColHeader>作成日</ColHeader>
                <ColHeader>点検名</ColHeader>
                <ColHeader>発電所</ColHeader>
                <ColHeader>タイプ</ColHeader>
                <ColHeader>作成者</ColHeader>
                <ColHeader></ColHeader>
              </tr>
            </thead>
            <TableBody>
              {inspections.map((inspection, i) => (
                <tr key={i}>
                  <Col>{inspection.date}</Col>
                  <Col className="font-medium text-gray-900">
                    {inspection.name}
                  </Col>
                  <Col>{inspection.windFarm.name}</Col>
                  <Col>
                    <InspectionTypeBadge type={inspection.type} />
                  </Col>
                  <Col>{inspection.author}</Col>
                  <Col>
                    <Link
                      to="/inspection"
                      state={{
                        inspection: inspection,
                        lastInspectionsIds: [
                          inspections[i + 1]?.id,
                          inspections[i + 2]?.id,
                        ],
                      }}
                      className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                    >
                      詳しく見る
                    </Link>
                  </Col>
                </tr>
              ))}
            </TableBody>
          </Table>
          <nav
            className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
            aria-label="Pagination"
          >
            <div className="flex justify-between sm:justify-end">
              <button
                onClick={() => fetchInspections(nextToken, inspections)}
                className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                もっと見る
              </button>
            </div>
          </nav>
        </Card>
      )}
    </Layout>
  );
};

export default Home;
